export enum PanelClientEditAssessmentSectionsEnum {
    SharesStocksMargin = 1,
    InvestmentCertificates
}
